import styled from 'styled-components'

export const FlexRow = styled.div`
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  align-items: baseline;
`

export const Col = styled.div`
  padding: 0 15px;
  height: inherit;
`



// WEBPACK FOOTER //
// ./src/components/Grid.js